import React from "react";

export const ServicesDetailsFaq2 = () => {
  return (
    <div className="accordion-wrap-three">
      <div className="accordion" id="accordionExample">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
               Awareness Cum Internal Auditing
            </button>
          </h2>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              Our Awareness Cum Internal Auditing training program provides participants with a 
              comprehensive understanding of internal auditing techniques and guidelines for auditing 
              management systems (ISO 19011:2018). This program covers various management systems, 
              including ISO 9001, IATF 16949, ISO 14001, ISO 45001, ISO 22000, ISO 50001, ISO 41001, 
              ISO 39001, ISO 29993, and ISO 27001.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
               AIAG Core Tools Training
            </button>
          </h2>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              Our ISO 10002:2018 awareness training program provides participants with a comprehensive 
              understanding of the guidelines for complaints handling in organizations. This program 
              covers the principles and processes for effective complaints handling, including planning, 
              implementation, and monitoring.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              VAS Trainings
            </button>
          </h2>
          <div
            id="collapseThree"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              Our VAS trainings provide participants with a comprehensive understanding of various topics, 
              including TQM (Total Quality Management), TPM (Total Productive Maintenance), New 7 Tools, 
              7QC Tools, Cost of Poor Quality, Kaizen, Poke-yoke, Waste Elimination, and more.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Soft Skills Training
            </button>
          </h2>
          <div
            id="collapseFour"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div className="accordion-body">
              <p>
              Our soft skills training program provides participants with a comprehensive understanding of 
              essential skills, including 5S Concepts, Benchmarking, Time Management, Motivation, 
              Communication, Work Culture, and Personality Development.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
